<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive && alive == true"></router-view>
    </keep-alive>-->
    <router-view v-if="$route.name === 'login'"></router-view>
    <mainFunc v-else />

    <!--     <van-tabbar v-show="$route.name=='task' || $route.name=='peopleList'||$route.name=='mainFunc'||$route.name=='set'" v-model="active" style="background: #f9f9f9">
      <van-tabbar-item @click="$router.replace({name:'task'})" >
        <span>任务</span>
        <template slot="icon" slot-scope="props">
          <div class="iconfont icon-workordermanagement font_bottom"></div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="$router.replace({name:'peopleList'})" v-show="userInfo.Fullfunc">
        <span>通讯录</span>
        <template slot="icon" slot-scope="props">
          <div class="iconfont font_bottom icon-tongxunlu"></div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="$router.replace({name:'mainFunc'})" v-show="userInfo.Fullfunc">
        <span>应用</span>
        <template slot="icon" slot-scope="props">
          <div class="iconfont font_bottom icon-applications"></div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item @click="$router.replace({name:'set'})" >
        <span>我</span>
        <template slot="icon" slot-scope="props">
          <div class="iconfont font_bottom icon-set"></div>
        </template>
      </van-tabbar-item>
    </van-tabbar>-->
    <!-- <van-progress v-show="showProcess" :percentage="processText" /> -->
    <van-popup v-model="showProcess" style="width: 100%">
      <van-progress :percentage="processText" pivot-text=" " />
    </van-popup>
  </div>
</template>

<script>
import Foot from "./components/commons/foot";
import { mapState } from "vuex";
import { Toast, CellSwipe, Dialog } from "vant";
import mainFunc from "./pages/application/mainFunc";
import { GetQueryString } from "@/utils/utils";
const defaultUsers = {
  rizhao: { Username: "rzwz_default", Password: "123456" },
  lypy_default: { Username: "lypy_default", Password: "123456" },
};

export default {
  name: "App",
  data() {
    return {
      showProcess: false,
      processText: 0,
      isLoading: false,
      active: 0,
      alive: true,
      init: false,
      pageDict: {
        // 'task':0,
        peopleList: 1,
        mainFunc: 2,
        set: 3,
      },
    };
  },
  components: {
    mainFunc,
  },
  computed: {
    ...mapState(["userInfo", "loginAsDefault"]),
  },
  mounted() {
    var name = this.$route.name;
    this.active = this.pageDict[name];
    document.addEventListener("deviceready", this.onDeviceReady, false);
    window.mainapp = this;

    var default_user = GetQueryString("default_user");
    if (default_user) {
      this.$store.commit("setLoginType", "default");
      let default_user_info = defaultUsers[default_user];
      if (default_user_info) {
        this.$store.commit("setDefaultUserInfo", default_user_info);
      }
    }
  },
  watch: {
    $route(to, from) {
      if (from.name == "login") {
        if (!this.userInfo || this.loginAsDefault) {
          this.$store.dispatch("init");
        }
        this.alive = false;
      }
      var name = this.$route.name;
      this.active = this.pageDict[name];
      if (to.meta.index == true) {
        console.log("listen");
        document.addEventListener("backbutton", this.onBackKeyDown, false);
      }
    },
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$toast("刷新成功");
        this.isLoading = false;
      }, 500);
    },
    initDefaultUser() {
      console.log("initDefaultUser")
      var default_user = GetQueryString("default_user");
      if (default_user) {
        let default_user_info = defaultUsers[default_user];
        if (default_user_info) {
          this.$store.commit("setDefaultUserInfo", default_user_info);
          this.$store.dispatch("loginAsDefault").then((x) => {
            this.initPage();
          }).catch(e=>{
            this.$router.replace({ name: "login" });  
          });
        } else {
          this.$router.replace({ name: "login" });
        }
      } else {
        this.$router.replace({ name: "login" });
      }
    },
    initiateUI() {
      var getRegistrationID = function () {
        // window.JPush.getRegistrationID(onGetRegistrationID);
      };
      var onGetRegistrationID = function (data) {
        try {
          console.log("JPushPlugin:registrationID is " + data);
          if (data.length == 0) {
            var t1 = window.setTimeout(getRegistrationID, 1000);
          }
        } catch (exception) {
          console.log(exception);
        }
      };

      try {
        // window.JPush.init();
        // window.JPush.setDebugMode(true);
        // window.setTimeout(getRegistrationID, 1000);
        // if (device.platform != "Android") {
        //   window.JPush.setApplicationIconBadgeNumber(0);
        // }
      } catch (exception) {
        console.log(exception);
      }
      document.addEventListener(
        "jpush.openNotification",
        this.onOpenNotification,
        false
      );
      document.addEventListener(
        "jpush.receiveNotification",
        this.onReceiveNotification,
        false
      );
      document.addEventListener(
        "jpush.receiveMessage",
        this.onReceiveMessage,
        false
      );
    },
    onDeviceReady() {
      console.log("onDeviceReady");
      document.addEventListener("backbutton", this.onBackKeyDown, false);
      // document.addEventListener("jpush.receiveRegistrationId", function (event) {

      //       }, false)
      // this.initiateUI()
    },
    onOpenNotification(event) {
      console.log(event);
      var data = event.extras["cn.jpush.android.EXTRA"];
      if (data.msg_type == "alarm") {
        this.$router.push({ name: "detail", params: { id: data.detail_id } });
      }
      if (data.msg_type == "task") {
        this.$router.push({
          name: "taskDetail",
          params: { task_id: data.detail_id },
        });
      }
    },
    onReceiveNotification(event) {
      console.log("rece");
      console.log(event);
    },
    onReceiveMessage(event) {
      console.log("message");
      console.log(event);
    },
    onBackKeyDown() {
      console.log("onBackKeyDown");
      var self = this;
      if (this.$route.meta.index !== true) {
        this.$router.go(-1);
      } else {
        Toast("再点击一次退出~");
        document.removeEventListener("backbutton", this.onBackKeyDown, false); // 注销返回键
        document.addEventListener("backbutton", this.exitApp, false); //绑定退出事件
        // 3秒后重新注册
        var intervalID = window.setInterval(function () {
          window.clearInterval(intervalID);
          document.removeEventListener("backbutton", self.exitApp, false); // 注销返回键
          document.addEventListener("backbutton", self.onBackKeyDown, false); // 返回键
        }, 1000);
      }
    },
    exitApp() {
      navigator.app.exitApp();
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
::-webkit-scrollbar {
  display: none;
}
th,
td {
  padding: 7px 0px !important;
}
.cell {
  padding-right: 0 !important;
}
.nav {
  text-align: center;
  height: 15px;
  width: 100%;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 13px;
  background: #3e76a0;
  color: white;
  line-height: 15px;
}
.van-tabbar-item__text {
  font-size: 13px !important;
}
.font_bottom {
  font-size: 22px;
}
.anchorBL {
  display: none;
}

.el-slider__runway {
  margin: 15px 0 5px 0;
}

.main_container {
  /* height: calc(100% - 46px); */
  background-color: transparent;
}

.head_right {
  position: absolute;
  right: 10px;
  font-size: 15px;
  color: #38f;
}
.head_left {
  position: absolute;
  left: 10px;
  font-size: 15px;
  color: #38f;
}
td {
  padding: 6px 0 !important;
}

.el-form--inline .el-form-item {
  margin-bottom: 5px !important;
  padding-left: 20px;
}

.head_alarm {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  background: white;
  color: black;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 2;
}

.van-cell-swipe__right {
  color: #ffffff;
  font-size: 15px;
  width: 65px;
  height: 44px;
  display: inline-block;
  text-align: center;
  line-height: 44px;
  background-color: #f44;
}

.van-dialog__message--withtitle {
  color: #252525;
  font-size: 16px;
}
.van-popup.van-popup--right {
  width: 100%;
  height: 99%;
  overflow: scroll;
}

.mainFunc {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: #fff;
}
.mainFunc .van-row {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.block_title {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  color: black;
  padding: 6px 15px 3px;
  background: #e4e4e4;
  width: 100%;
  height: 28px;
  line-height: 28px;
}
.time_style {
  font-size: 13px;
  margin-top: 2px;
  color: #9a9a9a;
}
.ui.divider {
  margin: 6px 0;
}
.van-cell__title {
  position: relative;
}
.screen_menus {
  font-size: 14px;
  color: #565656;
  text-align: center;
  padding: 2px 0;
  height: 56px;  
  line-height: 25px;
  border-bottom: 1px solid #e5e5e5;
}

.screen_menus_current {
  height: 25px;  
}
.popup {
  position: fixed !important;
  width: 100%;
  background-color: rgba(25, 25, 25, 0.69) !important;
  z-index: 10000;

  height: 78vh;
  overflow: auto;
}
.showlist-enter-active,
.showlist-leave-active {
  transition: all 0.3s;
  transform: translateY(0);
}
.showlist-enter,
.showlist-leave-active {
  opacity: 0;
  transform: translateY(-20px);
}
.van-hairline--bottom.van-nav-bar {
  background: rgb(249, 249, 249);
}

.active_icon {
  transform: rotate(90deg);
  color: rgb(17, 85, 204);
}

/*.van-dialog{
  top: 25%
}*/

.icon-back {
  background: #f99939;
  width: 30px;
  display: inline-block;
  text-align: center;
  height: 30px;
  line-height: 27px;
  border-radius: 3px;
  color: white;
  margin-right: 8px;
}

.icon-back-large {
  /* background: #fff; */
  display: inline-block;
  text-align: center;
  border-radius: 3px;
  color: #8d8d8d;
  font-size: 30px;
  margin-bottom: 2px;
}
.select > .van-cell {
  padding: 5px 15px;
}
.cellActive {
  background: #e2e2e2;
}
.select-cell {
  padding: 8px 15px;
}

.BMapLib_bubble_title,
.BMapLib_bubble_top {
  font-size: 2vh !important;
  height: 3vh !important;
  line-height: 3vh !important;
  font-weight: 600;
  background: #091939 !important;
  color: white;
}
.BMapLib_SearchInfoWindow {
  background: #091939 !important;
}
.BMapLib_SearchInfoWindow .BMapLib_bubble_tools div {
  background-color: #091939 !important;
  height: 18px !important;
}

.BMapLib_sendToPhone {
  display: none;
}
.popup_select {
  top: 76px;
}
.van-pull-refresh__track {
  z-index: 100;
}
body {
  position: relative !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue